import React from 'react'
import {AiFillApple} from 'react-icons/ai'
import {RiGooglePlayFill} from 'react-icons/ri'
import {GoCloudDownload} from 'react-icons/go'
import {GrGroup} from 'react-icons/gr'
import {TbHeartHandshake} from 'react-icons/tb'
import {ImAppleinc} from 'react-icons/im'

export const Hero = () => {

  return (
    <section className='font-Poppins'>


           <div className='bg-[ECF2FE] '> 
               <div className='container xl:max-w-[1280px] mx-auto  lg:flex'> 

                  <div className=' lg:w-1/2  mx-5 lg:mx-0 md:px-4 '> 
                    <h1 className='lg:mt-20 pt-10  sm:text-4xl text-3xl font-bold lg:w-full  '> Be part of a community, connect, and create lasting memories </h1>
                    <p className='mt-4 text-[0.9rem]   md:w-9/12 sm:text-lg lg:w-full text-textgray '> Discover and meet new people by connecting and making new friends with just a single click. </p>

                  

                    <div className='flex lg:justify-start justify-center text-[#ffffff] space-x-4 lg:mt-6 mt-10 '> 
                         <div className='flex  sm:w-36 w-fit px-1 h-10 hover:bg-primaryblue hover:text-[#ffffff] bg-[#000000]  hover:border-0 space-x-2 hover:cursor-pointer rounded-md'>
                           
                         <ImAppleinc className='text-2xl mt-1 '> </ImAppleinc>
                          <div className='' > 
                              <h1 className='text-[10px] mt-0.5  text-start'> Download on the  </h1>
                              <h1 className='mt-[-4px] text-start text-sm'> App Store</h1>
                          </div>
                        </div>

                         <div className='flex  sm:w-36 w-fit px-1 h-10 hover:bg-primaryblue hover:text-[#ffffff] bg-[#000000]  hover:border-0 space-x-2 hover:cursor-pointer rounded-md'>
                           
                          <img className='h-6 mt-2 ml-2' src='./image/google.webp' alt='google play'/>
                          <div className='' > 
                              <h1 className='text-[9px]  mt-1 text-start'> GET IT ON </h1>
                              <h1 className='mt-[-3px] text-sm'> Google Play</h1>
                          </div>
                        </div>
                    </div>
                    
                  </div>


                  <div className=' lg:w-1/2    lg:mx-0'> 
                    <div > 
                       <div className='flex justify-center lg:justify-end mt-6 '> 
                          <img  className='absolute w-[350px] sm:w-[450px] md:w-[500px] xl:w-[600px]  mx-auto' src='./image/shadow.svg  ' alt='' />
                         <img className=' relative lg:h-[35rem] xl:h-[37rem] sm:h-[35rem] mx-auto lg:mx-0  flex ' src='./image/herogirl.webp' alt=''/>
                       </div>
                       
                     
                      
                    </div>
                  </div>

                  
              </div> 
           </div>


              <div className='bg-primarygray'>
                  <div className='  container mx-auto xl:max-w-[1280px] pb-10  '>
                  {/* <div className='text-center'> 
                    <h1 className='font-bold md:text-5xl text-3xl'> Discover </h1>
                    <p className='mt-1'>  am venenatis, lectus magna fringilla urna,   </p>
                  </div> */}
                
                 <div  className='lg:grid  lg:grid-cols-2 flex flex-col-reverse'> 
                      
                
                      <div className='    '> 
                        <img className='  items-start h-[28rem]  sm:h-[31rem] lg:mr-20 mt-4 lg:mt-8   mx-auto  ' src='./image/device.webp' alt=''/>
                      </div> 
                      
                      <div className='     lg:mt-[8rem]  '> 
                          <h1 className='font-semibold text-2xl sm:text-3xl md:text-4xl mt-8  lg:mx-0 lg:text-start mx-5 text-center'>Connect & Chat </h1> 
                          <p className='  mx-5 lg:mt-2 lg:mx-0 text-[0.9rem] sm:text-lg  text-center lg:text-start '> With Mslockdown you can build great friendships and keep the conversation going by messaging your friends and family for free. As our voices matter as much as our words, you can send personalized voice messages and enjoy the privilege of hearing the voice of your loved ones from anywhere in the world   </p>
                      </div> 
                 </div>

              </div>

              </div>

             {/* <div className='bg-primarygray'>
                  <div className='  container xl:max-w-[1280px]  mx-auto pt-14 pb-6'>
                  
                
                 <div  className='flex flex-col-reverse lg:flex-row xl:justify-between justify-around'> 

                     <div className='lg:w-1/2   mt-4 lg:mt-28 '> 
                          <h1 className='lg:float-right lg:w-4/5 text-center text-2xl font-semibold lg:text-start'>Video Chat </h1> 
                          <p className='lg:w-4/5 lg:flex  lg:mt-4 lg:float-right mx-5 lg:mx-0 text-center lg:text-start'> Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor   amet luctus venenatis, lectus magna fringilla urna, porttitor  amet luctus venenatis, lectus magna fringilla urna, porttitor   </p>
                      </div> 
                
                      <div className='lg:w-4/12   flex justify-start'> 
                      
                        <img className='md:max-h-[400px] lg:max-h-[450px] xl:max-h-[500px] mx-auto lg:mx-0' src='./image/videchat.png' alt=''/>
                      </div> 
                      
                     
                 </div>

              </div> 

             </div> */}


             <div className='bg-[#F6F6F6]'> 
                     <div className=' pt-6 container xl:max-w-[1280px] pb-10 mx-auto'>  
                  <div className=' mx-5 lg:mx-0'> 
                      <h1 className='text-center text-2xl sm:text-3xl md:text-4xl mt-2 font-semibold'> Connecting People </h1>
                      <p className='text-center text-[0.9rem]  sm:text-lg lg:w-3/4 lg:mx-auto'>  Organize your social interactions and join conversations globally. With millions of people around the world, there's a match for everyone. </p>
                      <img className=' w-full  lg:w-[35rem] object-cover mt-4 mx-auto' src='./image/dots.png' alt='' />

                      <div className='lg:flex lg:space-x-5 mt-8 grid  justify-center ' > 
                           <div className='flex space-x-10'>
                                  <div className='flex space-x-10'> 
                                      <div> 
                                          <h1 className='font-bold text-xl'> +150M </h1> 
                                          <div className='flex'> 
                                            <GoCloudDownload className='mt-1'> </GoCloudDownload>
                                            <h1 className='ml-0.5'> Download </h1> 

                                        </div>
                                      </div>

                                        <div> 
                                          <img className='h-10 mt-2 ' src='./image/line.png' alt=''/> 
                                        </div>
                                  </div>

                             <div className='flex space-x-10 '> 
                                      <div> 
                                          <h1 className='font-bold text-xl'> +150M </h1> 
                                          <div className='flex'> 
                                            <GrGroup className='mt-1'> </GrGroup>
                                            <h1 className='ml-0.5'> Members </h1> 

                                        </div>
                                      </div>

                                        <div className='hidden lg:inline'> 
                                          <img className='h-10 mt-2' src='./image/line.png' alt=''/> 
                                        </div>
                                  </div>
                            </div> 
                            

                             <div className='mx-auto mt-6 lg:mt-0 lg:mx-0'> 
                                <h1 className='font-bold text-xl text-center lg:text-start'> +150M </h1> 
                                <div className='flex'> 
                                    <TbHeartHandshake className='mt-1'> </TbHeartHandshake>
                                    <h1 className='ml-0.5'> Communites </h1> 

                                </div>
                            </div>
                      </div>
                  </div>
              </div>

             </div>

    </section>
  )
}
